
import type { BlockOptionDefinition } from '../../node_modules/@blokkli/editor/dist/runtime/types/blokkOptions.ts'

export type RuntimeBlockOptionArray = {
  [T in BlockOptionDefinition as T['type']]: [T['type'], T['default']]
}[BlockOptionDefinition['type']]

export type RuntimeBlockOptions = {
  contact_box_generic: {
    isHidden: boolean
  },
  footer_section_contact_details: {},
  footer_section_links: {},
  footer_section_metalinks: {},
  footer_section_social_media_link: {},
  table_markup: {
    mobileStyle: 'vertical' | 'horizontal'
    width: 'narrow' | 'full'
    headingVertical: boolean
    equalWidths: boolean
    isHidden: boolean
  },
  from_library: {},
  accordion_element: {
    showDownload: boolean
    isHidden: boolean
  },
  button: {
    color: 'GREEN_ALT' | 'BERRY' | 'ORANGE'
    isPrimary: boolean
    isHidden: boolean
  },
  chart: {
    chartType: 'bar' | 'pie' | 'line' | 'matrix' | 'map'
    mutedCount: number
    decimalPoints: number
    width: 'narrow' | 'full'
    pieOffsetX: number
    linePaddingBottom: number
    linePaddingTop: number
    linePaddingLeft: number
    rotationOffset: number
    colorPalette: 'mixed' | 'berry' | 'orange' | 'blue'
    barDistribution: 'percentage' | 'largest'
    valuesOnHover: boolean
    isHidden: boolean
  },
  contact_box: {
    showImage: boolean
    isHidden: boolean
  },
  container: {
    marginTop: 'small' | 'normal' | 'large' | 'huge'
    isHidden: boolean
  },
  editorial_title: {
    isHidden: boolean
  },
  fact: {
    factStyle: 'blue' | 'orange'
    isHidden: boolean
  },
  frame: {
    isHidden: boolean
  },
  grid: {
    marginTop: 'small' | 'normal' | 'large' | 'huge'
    isHidden: boolean
  },
  image: {
    aspectRatio: 'square' | 'original' | 'wide'
    enlarge: 'no' | 'yes'
    isHidden: boolean
  },
  link_box: {
    isHidden: boolean
  },
  links: {
    isHidden: boolean
  },
  mailxpert: {
    isHidden: boolean
  },
  node_teaser: {
    teaserColor: 'BLUE' | 'BLUE_GRADIENT' | 'CYAN' | 'CYAN_LIGHTER' | 'BERRY' | 'LIME' | 'LIME_LIGHT'
    isHidden: boolean
  },
  person_box: {
    isHidden: boolean
  },
  product_teaser: {
    isHidden: boolean
  },
  section_title: {
    headingLevel: 'h2' | 'h3'
    showInNavigation: boolean
    isHidden: boolean
  },
  table: {
    isHidden: boolean
  },
  table_row: {
    isHidden: boolean
  },
  teaser_box: {
    hideTextOnMobile: boolean
    teaserColor: 'BLUE' | 'BLUE_GRADIENT' | 'CYAN' | 'CYAN_LIGHTER' | 'BERRY' | 'LIME' | 'LIME_LIGHT'
    isHidden: boolean
  },
  text: {
    isHidden: boolean
  },
  video_remote: {
    anchorId: string
    isHidden: boolean
  },
  view: {
    teaserType: 'article' | 'card'
    teaserColor: 'BLUE' | 'BLUE_GRADIENT' | 'CYAN' | 'CYAN_LIGHTER' | 'BERRY' | 'LIME' | 'LIME_LIGHT'
    isHidden: boolean
  },
  webform: {
    isHidden: boolean
  },
  blokkli_fragment: {}
}

export const BLOCK_OPTIONS: Record<string, Record<string, RuntimeBlockOptionArray>> = {
  "contact_box_generic": {
    "isHidden": [
      "checkbox",
      false
    ]
  },
  "table_markup": {
    "isHidden": [
      "checkbox",
      false
    ],
    "mobileStyle": [
      "radios",
      "vertical"
    ],
    "width": [
      "radios",
      "narrow"
    ],
    "headingVertical": [
      "checkbox",
      false
    ],
    "equalWidths": [
      "checkbox",
      false
    ]
  },
  "accordion_element": {
    "isHidden": [
      "checkbox",
      false
    ],
    "showDownload": [
      "checkbox",
      false
    ]
  },
  "button": {
    "isHidden": [
      "checkbox",
      false
    ],
    "color": [
      "radios",
      "GREEN_ALT"
    ],
    "isPrimary": [
      "checkbox",
      true
    ]
  },
  "chart": {
    "isHidden": [
      "checkbox",
      false
    ],
    "chartType": [
      "radios",
      "bar"
    ],
    "mutedCount": [
      "number",
      0
    ],
    "decimalPoints": [
      "number",
      1
    ],
    "width": [
      "radios",
      "narrow"
    ],
    "pieOffsetX": [
      "range",
      0
    ],
    "linePaddingBottom": [
      "range",
      0
    ],
    "linePaddingTop": [
      "range",
      0
    ],
    "linePaddingLeft": [
      "range",
      0
    ],
    "rotationOffset": [
      "range",
      0
    ],
    "colorPalette": [
      "radios",
      "berry"
    ],
    "barDistribution": [
      "radios",
      "percentage"
    ],
    "valuesOnHover": [
      "checkbox",
      false
    ]
  },
  "contact_box": {
    "isHidden": [
      "checkbox",
      false
    ],
    "showImage": [
      "checkbox",
      true
    ]
  },
  "container": {
    "marginTop": [
      "radios",
      "normal"
    ],
    "isHidden": [
      "checkbox",
      false
    ]
  },
  "editorial_title": {
    "isHidden": [
      "checkbox",
      false
    ]
  },
  "fact": {
    "isHidden": [
      "checkbox",
      false
    ],
    "factStyle": [
      "radios",
      "blue"
    ]
  },
  "frame": {
    "isHidden": [
      "checkbox",
      false
    ]
  },
  "grid": {
    "marginTop": [
      "radios",
      "normal"
    ],
    "isHidden": [
      "checkbox",
      false
    ]
  },
  "image": {
    "isHidden": [
      "checkbox",
      false
    ],
    "aspectRatio": [
      "radios",
      "wide"
    ],
    "enlarge": [
      "radios",
      "no"
    ]
  },
  "link_box": {
    "isHidden": [
      "checkbox",
      false
    ]
  },
  "links": {
    "isHidden": [
      "checkbox",
      false
    ]
  },
  "mailxpert": {
    "isHidden": [
      "checkbox",
      false
    ]
  },
  "node_teaser": {
    "teaserColor": [
      "radios",
      "BLUE"
    ],
    "isHidden": [
      "checkbox",
      false
    ]
  },
  "person_box": {
    "isHidden": [
      "checkbox",
      false
    ]
  },
  "product_teaser": {
    "isHidden": [
      "checkbox",
      false
    ]
  },
  "section_title": {
    "isHidden": [
      "checkbox",
      false
    ],
    "headingLevel": [
      "radios",
      "h2"
    ],
    "showInNavigation": [
      "checkbox",
      true
    ]
  },
  "table": {
    "isHidden": [
      "checkbox",
      false
    ]
  },
  "table_row": {
    "isHidden": [
      "checkbox",
      false
    ]
  },
  "teaser_box": {
    "teaserColor": [
      "radios",
      "BLUE"
    ],
    "isHidden": [
      "checkbox",
      false
    ],
    "hideTextOnMobile": [
      "checkbox",
      false
    ]
  },
  "text": {
    "isHidden": [
      "checkbox",
      false
    ]
  },
  "video_remote": {
    "anchorId": [
      "text",
      ""
    ],
    "isHidden": [
      "checkbox",
      false
    ]
  },
  "view": {
    "teaserColor": [
      "radios",
      "BLUE"
    ],
    "isHidden": [
      "checkbox",
      false
    ],
    "teaserType": [
      "radios",
      "card"
    ]
  },
  "webform": {
    "isHidden": [
      "checkbox",
      false
    ]
  }
}
